interface LanguageMapping {
  id: string;
  extensions: string[];
  aliases?: string[];
  mimeTypes?: string[];
}

const LANGUAGE_MAPPINGS: LanguageMapping[] = [
  // Web Technologies
  { id: 'javascript', extensions: ['js', 'mjs', 'cjs'], aliases: ['js'], mimeTypes: ['application/javascript'] },
  { id: 'typescript', extensions: ['ts'], aliases: ['ts'], mimeTypes: ['application/typescript'] },
  { id: 'javascriptreact', extensions: ['jsx'], aliases: ['jsx', 'react'] },
  { id: 'typescriptreact', extensions: ['tsx'], aliases: ['tsx'] },
  { id: 'html', extensions: ['html', 'htm'], mimeTypes: ['text/html'] },
  { id: 'css', extensions: ['css'], mimeTypes: ['text/css'] },
  { id: 'scss', extensions: ['scss'], aliases: ['sass'] },
  { id: 'less', extensions: ['less'] },
  { id: 'json', extensions: ['json'], mimeTypes: ['application/json'] },
  { id: 'jsonc', extensions: ['jsonc'] },
  { id: 'xml', extensions: ['xml', 'xsd', 'xsl', 'xslt'], mimeTypes: ['application/xml'] },
  
  // Programming Languages (diğer diller aynı şekilde...)
  { id: 'python', extensions: ['py', 'pyw', 'pyi'], mimeTypes: ['text/x-python'] },
  { id: 'java', extensions: ['java'], mimeTypes: ['text/x-java-source'] },
  { id: 'csharp', extensions: ['cs', 'csx'], aliases: ['c#'] },
  { id: 'cpp', extensions: ['cpp', 'cc', 'cxx', 'c++'], aliases: ['c++'] },
  { id: 'c', extensions: ['c', 'h'], mimeTypes: ['text/x-c'] },
  { id: 'go', extensions: ['go'] },
  { id: 'rust', extensions: ['rs'], aliases: ['rs'] },
  { id: 'php', extensions: ['php', 'phtml', 'php3', 'php4', 'php5'] },
  { id: 'ruby', extensions: ['rb', 'rbw'], aliases: ['rb'] },
  { id: 'swift', extensions: ['swift'] },
  { id: 'kotlin', extensions: ['kt', 'kts'] },
  { id: 'scala', extensions: ['scala', 'sc'] },
  { id: 'dart', extensions: ['dart'] },
  
  // Functional Languages
  { id: 'fsharp', extensions: ['fs', 'fsx', 'fsi'], aliases: ['f#'] },
  { id: 'haskell', extensions: ['hs', 'lhs'] },
  { id: 'elixir', extensions: ['ex', 'exs'] },
  { id: 'erlang', extensions: ['erl', 'hrl'] },
  { id: 'clojure', extensions: ['clj', 'cljs', 'cljc'] },
  
  // Shell & Scripts
  { id: 'shell', extensions: ['sh', 'bash', 'zsh', 'fish'], aliases: ['bash', 'zsh'] },
  { id: 'powershell', extensions: ['ps1', 'psm1', 'psd1'] },
  { id: 'bat', extensions: ['bat', 'cmd'] },
  
  // Data & Config
  { id: 'yaml', extensions: ['yml', 'yaml'], mimeTypes: ['application/x-yaml'] },
  { id: 'toml', extensions: ['toml'] },
  { id: 'ini', extensions: ['ini', 'cfg', 'conf'] },
  { id: 'properties', extensions: ['properties'] },
  { id: 'dockerfile', extensions: ['dockerfile'], aliases: ['docker'] },
  { id: 'makefile', extensions: ['makefile', 'mk'], aliases: ['make'] },
  
  // Documentation
  { id: 'markdown', extensions: ['md', 'markdown', 'mdown', 'mkd'] },
  { id: 'restructuredtext', extensions: ['rst', 'rest'] },
  { id: 'asciidoc', extensions: ['adoc', 'asciidoc'] },
  { id: 'tex', extensions: ['tex', 'latex'] },
  
  // Database
  { id: 'sql', extensions: ['sql', 'ddl', 'dml'] },
  { id: 'plsql', extensions: ['pls', 'plsql'] },
  { id: 'mysql', extensions: ['mysql'] },
  { id: 'pgsql', extensions: ['pgsql', 'psql'] },
  
  // Mobile
  { id: 'objective-c', extensions: ['m', 'mm'], aliases: ['objc'] },
  { id: 'objective-cpp', extensions: ['mm'] },
  
  // Game Development
  { id: 'lua', extensions: ['lua'] },
  { id: 'gdscript', extensions: ['gd'] },
  
  // Other Languages
  { id: 'r', extensions: ['r', 'rmd'] },
  { id: 'matlab', extensions: ['m', 'mat'] },
  { id: 'perl', extensions: ['pl', 'pm', 'perl'] },
  { id: 'tcl', extensions: ['tcl'] },
  { id: 'vb', extensions: ['vb'], aliases: ['vbnet', 'visualbasic'] },
  { id: 'pascal', extensions: ['pas', 'pp', 'inc'] },
  { id: 'fortran', extensions: ['f', 'for', 'f90', 'f95'] },
  { id: 'cobol', extensions: ['cob', 'cbl', 'cobol'] },
  
  // Markup & Styling
  { id: 'handlebars', extensions: ['hbs', 'handlebars'] },
  { id: 'mustache', extensions: ['mustache'] },
  { id: 'twig', extensions: ['twig'] },
  { id: 'pug', extensions: ['pug', 'jade'] },
  { id: 'stylus', extensions: ['styl', 'stylus'] },
  
  // Configuration & Build
  { id: 'gradle', extensions: ['gradle'] },
  { id: 'groovy', extensions: ['groovy', 'gvy', 'gy', 'gsh'] },
  { id: 'cmake', extensions: ['cmake'] },
  { id: 'nginx', extensions: ['nginx', 'conf'] },
  { id: 'apache', extensions: ['htaccess'] },
  
  // Version Control
  { id: 'ignore', extensions: ['gitignore', 'dockerignore', 'eslintignore'] },
  
  // Logs
  { id: 'log', extensions: ['log', 'out'] },
  
  // Binary/Other
  { id: 'plaintext', extensions: ['txt', 'text'] },
];

// Lazy initialization of extension map
let extensionMap: Map<string, string> | null = null;

function getExtensionMap(): Map<string, string> {
  if (!extensionMap) {
    extensionMap = new Map();
    LANGUAGE_MAPPINGS.forEach(mapping => {
      mapping.extensions.forEach(ext => {
        extensionMap!.set(ext.toLowerCase(), mapping.id);
      });
    });
  }
  return extensionMap;
}

function extractExtension(fileName: string): string {
  const parts = fileName.toLowerCase().split('.');
  
  if (parts.length >= 2) {
    const lastPart = parts[parts.length - 1];
    const secondLastPart = parts[parts.length - 2];
    
    // Handle compound extensions like .spec.ts, .test.js
    if (['spec', 'test', 'min', 'prod', 'dev'].includes(secondLastPart)) {
      return lastPart;
    }
    
    // Handle dotfiles
    if (parts[0] === '' && parts.length === 2) {
      return parts[1];
    }
    
    return lastPart;
  }
  
  return parts[parts.length - 1] || '';
}

function handleSpecialCases(fileName: string): string | null {
  const lowerFileName = fileName.toLowerCase();
  
  const specialFiles: { [key: string]: string } = {
    'dockerfile': 'dockerfile',
    'makefile': 'makefile',
    'cmake': 'cmake',
    'cmakelists.txt': 'cmake',
    'gemfile': 'ruby',
    'rakefile': 'ruby',
    'podfile': 'ruby',
    'vagrantfile': 'ruby',
    'procfile': 'yaml',
    'jenkinsfile': 'groovy',
    '.eslintrc': 'json',
    '.babelrc': 'json',
    '.prettierrc': 'json',
    'package.json': 'json',
    'composer.json': 'json',
    'tsconfig.json': 'jsonc',
    'launch.json': 'jsonc',
    'settings.json': 'jsonc',
  };

  if (specialFiles[lowerFileName]) {
    return specialFiles[lowerFileName];
  }

  if (lowerFileName.startsWith('.env')) return 'properties';
  if (lowerFileName.includes('license')) return 'plaintext';
  if (lowerFileName.includes('readme')) return 'markdown';
  if (lowerFileName.includes('changelog')) return 'markdown';
  
  return null;
}

export const getLanguageFromExtension = (fileName: string): string => {
  if (!fileName) return 'plaintext';

  const extension = extractExtension(fileName);
  return getExtensionMap().get(extension) || handleSpecialCases(fileName) || 'plaintext';
};

export const getSupportedLanguages = (): LanguageMapping[] => {
  return [...LANGUAGE_MAPPINGS];
};

export const isLanguageSupported = (languageId: string): boolean => {
  return LANGUAGE_MAPPINGS.some(mapping => 
    mapping.id === languageId || 
    mapping.aliases?.includes(languageId)
  );
};

export const getLanguageInfo = (languageId: string): LanguageMapping | null => {
  return LANGUAGE_MAPPINGS.find(mapping => mapping.id === languageId) || null;
};

export type { LanguageMapping };